package pnemonic.balloon_pop.view.difficulty

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.SentimentNeutral
import androidx.compose.material3.Icon
import androidx.compose.material3.IconToggleButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalHapticFeedback
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.Dp
import pnemonic.BooleanCallback
import pnemonic.balloon_pop.view.theme.AppTheme
import pnemonic.balloon_pop.view.theme.colorButton
import pnemonic.balloon_pop.view.theme.modifierButton
import pnemonic.balloon_pop.view.theme.modifierIcon
import pnemonic.balloon_pop.view.theme.sizeButton
import pnemonic.compose.toggle

private val colorButtonSelected = Color.Yellow

@Composable
fun MediumButton(
    enabled: Boolean = false,
    size: Dp = sizeButton,
    onChange: BooleanCallback
) {
    val haptic = LocalHapticFeedback.current

    IconToggleButton(
        checked = enabled,
        onCheckedChange = { checked ->
            haptic.toggle(checked)
            onChange(checked)
        },
        modifier = Modifier.modifierButton(size = size)
    ) {
        val tint = if (enabled) colorButtonSelected else colorButton
        Icon(
            imageVector = Icons.Default.SentimentNeutral,
            contentDescription = "😐",
            tint = tint,
            modifier = Modifier.modifierIcon(size = size)
        )
    }
}

@Composable
@Preview
private fun Preview0() {
    AppTheme {
        MediumButton(false) {}
    }
}

@Composable
@Preview
private fun Preview1() {
    AppTheme {
        MediumButton(true) {}
    }
}